// extracted by mini-css-extract-plugin
export default {"tAc":"Terms&Condition_tAc__b8i5M","tAc__content":"Terms&Condition_tAc__content__hiltj"};